import cssUtil from 'gw-portals-util-js/CssUtil';

import template from 'text!./RadioSelect.html';
import styles from './RadioSelect-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(template, styles);

export default {
    template: hashedTemplate,
    bindings: {
        model: '=',
        options: '=',
        explicitErrorMessage: '@?'
    },
    controller: function controller() {
        var ctrl = this;
        ctrl.select = function (choice) {
            ctrl.model.value = choice;
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/radioselect/components/RadioSelect.js
// module id = 1147
// module chunks = 0